import { ArrowRight, ClipboardCheck } from 'lucide-react'
import Link from 'next/link'
import { renderRichText } from './richText'
import type {
  HubMethodologyCardSection,
  HubSectionComponentProps,
} from './types'

export function HubMethodologyCard({
  section,
}: HubSectionComponentProps<HubMethodologyCardSection>) {
  if (!section.body.trim()) return null

  return (
    <aside
      id={section.id}
      aria-label={section.kicker ?? 'Methodology'}
      className='flex flex-col gap-3 rounded-2xl border-[0.5px] border-border bg-white p-5'
    >
      <div className='flex items-center gap-2'>
        <ClipboardCheck
          className='size-4 text-foreground-secondary'
          aria-hidden='true'
        />
        <p className='text-xs font-semibold uppercase tracking-wide text-ds-text-quaternary'>
          {section.kicker ?? 'How we picked'}
        </p>
      </div>
      {section.title && (
        <h3 className='font-display text-lg font-semibold leading-6 text-foreground'>
          {section.title}
        </h3>
      )}
      <p className='text-sm leading-6 text-foreground-secondary'>
        {renderRichText(section.body)}
      </p>
      <Link
        href={section.linkHref}
        className='inline-flex items-center gap-1 text-sm font-semibold text-info-700 hover:underline'
      >
        {section.linkLabel}
        <ArrowRight className='size-3.5' aria-hidden='true' />
      </Link>
    </aside>
  )
}
